import React, { useContext } from 'react';
import { CSVReader } from 'react-papaparse';
import { SerialNumbersCtx } from '../../../pages/SerialNumbersPage';

const SerialNumbersCSVUploader = () => {
  const { setDataCSV } = useContext(SerialNumbersCtx);

  const handleOnDrop = (data) => {
    const Keys = data[0].data;
    const columns = Keys.map((v, idx) => {
      return {
        id: idx,
        label: v,
        field: v,
      };
    });
    const rows = data.slice(1)
      .map((row) => {
        return row.data;
      })
      .map((row) => {
        return row.map((r, idx) => {
          return {
            Key: Keys[idx],
            Value: r,
          };
        });
      })
      .filter((row) => {
        return row.some((attr) => { return 'serial' === attr.Key && !!attr.Value; });
      });

    setDataCSV({ Keys, columns, rows });
  };

  const handleOnError = (err, file, inputElem, reason) => {
    console.log(err, file, inputElem, reason);
  };

  const handleOnRemoveFile = () => {
    setDataCSV(null);
  };

  return (
    <>
      <CSVReader
        onDrop={ handleOnDrop }
        onError={ handleOnError }
        addRemoveButton
        onRemoveFile={ handleOnRemoveFile }
      >
        <span>Drop CSV file here or click to upload.</span>
      </CSVReader>
    </>
  );
};

export default SerialNumbersCSVUploader;
